// extracted by mini-css-extract-plugin
export var logo = "_ly-2";
export var logoWrapper = "_ly-1";
export var strip = "_ly-0";